import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { entries } from '../helpers/common';

function SelfSubmittingForm({ method, action, data, ...formProps }) {
  const formRef = useRef();

  useEffect(() => {
    formRef.current.submit();
  }, []);

  return (
    <form method={method} action={action} ref={formRef} {...formProps}>
      {data &&
        entries(data).map(([name, value], index) => (
          <input key={index} type="hidden" name={name} value={value} />
        ))}
    </form>
  );
}

SelfSubmittingForm.propTypes = {
  action: PropTypes.string.isRequired,
  method: PropTypes.oneOf(['POST', 'PUT', 'GET']).isRequired,
};

export default SelfSubmittingForm;
